import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

declare var jQuery:any;
declare var $:any;

@Injectable({
	providedIn:'root'
})
export class SeoService {
	
	constructor(private meta: Meta) {}

	generateTags(config){
		config = {
			title: " ",
			description: "Hola Amigos",
			slug: " ",
			...config
		}
		this.meta.updateTag({name: 'description', content: config.description})
	}

	closeMenu(){
		console.log('cierra el menu');
		$('button.menu').removeClass('open');
		$('nav.mobile').removeClass('mobile');
	}
}